<template>

	<a-modal title="修改头像" :visible="visible" :maskClosable="false" :confirmLoading="confirmLoading" :width="400" :footer="null"
	 @cancel="cancelHandel">
		<a-row>
			<!-- <a-col :xs="24" :md="12" :style="{height: '350px'}">
				<vue-cropper ref="cropper" :img="imgsrc" :info="true" :autoCrop="options.autoCrop" :autoCropWidth="options.autoCropWidth"
				 :autoCropHeight="options.autoCropHeight" :fixedBox="options.fixedBox" @realTime="realTime">
				</vue-cropper>
			</a-col> -->
			<a-col :xs="24" :md="12" :style="{height: '350px'}">
				<div class="avatar-upload-preview">
					<img :src="imgsrc" />
				</div>
			</a-col>
		</a-row>
		<br>
		<a-row>
			<a-col :lg="2" :md="2">
				<!-- <a-upload action="https://coa.anliantest.com/oaProxyApi/proxyPython/file/upload" :headers="headers" name="file" :data="{ type: 'image',dept_id:dept_id }"
				 method="post" :beforeUpload="beforeUpload" @change="handleChange" :show-upload-list="false">
					<a-button icon="upload">选择图片</a-button>
				</a-upload> -->
				<!-- <a-upload :action="action" :headers="headers" :name="data.name" :remove="removeFile" @preview="previewFile"
					:data="upInfo" method="post" :beforeUpload="beforeUpload" @change="handleChange">
						<a-button>
							<a-icon type="upload" /> 上传文件 </a-button>
				</a-upload> -->
				<a-upload :action="action" :headers="headers" name="file" :data="{ types: 'avatar',path: 'company' + this.$store.state.user.info.deptId + '/', delFlag: 0}"
				 method="post" :beforeUpload="beforeUpload" @change="handleChange" :show-upload-list="false">
					<a-button icon="upload">选择图片</a-button>
				</a-upload>
			</a-col>
			<!-- <a-col :lg="{span: 1, offset: 2}" :md="2">
				<a-button icon="plus" @click="changeScale(1)" />
			</a-col>
			<a-col :lg="{span: 1, offset: 1}" :md="2">
				<a-button icon="minus" @click="changeScale(-1)" />
			</a-col>
			<a-col :lg="{span: 1, offset: 1}" :md="2">
				<a-button icon="undo" @click="rotateLeft" />
			</a-col>
			<a-col :lg="{span: 1, offset: 1}" :md="2">
				<a-button icon="redo" @click="rotateRight" />
			</a-col> -->
			<a-col :lg="{span: 2, offset: 18}" :md="2">
				<a-button type="primary" @click="finish('blob')">保存</a-button>
			</a-col>
		</a-row>
	</a-modal>

</template>
<script>
	import {
		user_update
	} from '@/api/assetmenag'
	import storage from 'store'
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	export default {
		data() {
			return {
				action: process.env.VUE_APP_API_BASE_URL  + '/file/file/upload',
				visible: false,
				id: null,
				confirmLoading: false,
				fileList: [],
				uploading: false,
				options: {
					// img: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
					img: '',
					autoCrop: true,
					autoCropWidth: 200,
					autoCropHeight: 200,
					fixedBox: true
				},
				previews: {},
				file_name: '',
				asset_sn: '',
				dept_id: '',
				fileList: [],
				imgsrc: process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file?bucketName=avatar&path=/' + this.$store.getters.avatar,
				headers: {}
			}
		},
		created(){
				    console.log( this.$store.getters.avatar,' this.$store.getters.userInfo.avatar==================')
			// this.imgsrc= this.$store.getters.userInfo.avatar
			// this.imgsrc = process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file?bucketName=avatar&path=/' + this.$store.getters.avatar
		},
		methods: {
			edit(id) {
				this.visible = true
				this.id = id
				/* 获取原始头像 */
			},
			close() {
				this.id = null
				this.visible = false
			},
			cancelHandel() {
				this.close()
			},
			changeScale(num) {
				num = num || 1
				this.$refs.cropper.changeScale(num)
			},
			rotateLeft() {
				this.$refs.cropper.rotateLeft()
			},
			rotateRight() {
				this.$refs.cropper.rotateRight()
			},
			//上传文件
			handleChange(info) {
				if (info.file.status === 'done') {
					if (info.file.response.code != 200) {
						this.$message.error(info.file.response.msg)
						return
					}
					// console.log(info.file.response, 'info.file.response========================')
					this.$store.commit('SET_AVATAR', info.file.response.data.url[0].path)
					this.imgsrc = process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file?bucketName=avatar&path=/' + this.$store.getters.avatar
					this.$message.success('上传成功')
				} else if (info.file.status === 'error') {
					this.$message.error('上传失败')
				}
				// this.imgsrc='https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path='+file.file.response.data
				// this.imgsrc = process.env.VUE_APP_API_BASE_URL  + '/file/file/upload'
			},
			// 上传各式限制
			beforeUpload(file) {
				const tok = storage.get(ACCESS_TOKEN)
				this.headers = {
					token: tok
				}
				console.log(this.headers, 'this.headers================')
				this.dept_id = this.$store.getters.userInfo.deptId
				var isType = true
				this.file_name = file.name
				const isLt2M = file.size / 1024 / 1024 < 10
				if (!isLt2M) {
					this.$message.error('上传头文件大小不能超过 10MB!')
				}

				return isLt2M && isType
			},

			// 上传图片（点击上传按钮）
			finish(type) {
				//  this.$store.commit('SET_AVATAR', result.avatar || '/avatar2.jpg')
				user_update({
					avatar: this.$store.getters.avatar,
					userId:this.$store.getters.userInfo.userId
				}).then((response) => {
					console.log(response)
					if(response.code==200){
						this.$message.success('上传成功')
						this.visible = false
						location.reload();
					}else{
						this.$message.success(response.msg)
					}
				})
				// const _this = this
				// const formData = new FormData()
				// // 输出
				// if (type === 'blob') {
				// 	this.$refs.cropper.getCropBlob((data) => {
				// 		const img = window.URL.createObjectURL(data)
				// 		this.model = true
				// 		this.modelSrc = img
				// 		formData.append('file', data, this.fileName)
				// 		user_update({
				// 			avatar:_this.imgsrc,
				// 			userId:_this.$store.getters.userInfo.userId
				// 		}).then((response) => {
				// 				console.log(response)
				// 				// var res = response.data
				// 				// if (response.status === 'done') {
				// 				//   _this.imgFile = ''
				// 				//   _this.headImg = res.realPathList[0] // 完整路径
				// 				//   _this.uploadImgRelaPath = res.relaPathList[0] // 非完整路径
				// 				//   _this.$message.success('上传成功')
				// 				//   this.visible = false
				// 				// }
				// 				_this.$message.success('上传成功')
				// 				_this.$emit('ok', response.url)
				// 				_this.visible = false
				// 			})
				// 	})
				// } else {
				// 	this.$refs.cropper.getCropData((data) => {
				// 		this.model = true
				// 		this.modelSrc = data
				// 	})
				// }
			},
			okHandel() {
				const vm = this

				vm.confirmLoading = true
				setTimeout(() => {
					vm.confirmLoading = false
					vm.close()
					vm.$message.success('上传头像成功')
				}, 2000)
			},

			realTime(data) {
				this.previews = data
			}
		}
	}
</script>

<style lang="less" scoped>
	.avatar-upload-preview {
		position: absolute;
		top: 50%;
		transform: translate(50%, -50%);
		width: 180px;
		height: 180px;
		border-radius: 50%;
		box-shadow: 0 0 4px #ccc;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
		}
	}
</style>
